import { render, staticRenderFns } from "./GExport.vue?vue&type=template&id=2c41a95b"
import script from "./GExport.vue?vue&type=script&lang=js"
export * from "./GExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports